// extracted by mini-css-extract-plugin
export var askAiIcon = "_qc-9";
export var container = "_qc-0";
export var groupSeparator = "_qc-a";
export var highlight = "_qc-4";
export var resultIcon = "_qc-5";
export var resultItem = "_qc-7";
export var resultSubtitle = "_qc-3";
export var resultTitle = "_qc-2";
export var resultsList = "_qc-1";
export var searchGroup = "_qc-6";
export var selected = "_qc-8";